module.exports = __webpack_public_path__ + "img/憨笑.261f0086.png";